
import { extend } from 'flarum/extend'
import IndexPage from 'flarum/components/IndexPage'
import AddNews from './components/AddNews'
import Field from '../common/Field'
import NewsState from './states/NewsState'

app.initializers.add('fstln/flarum-ext-news', () => {

  app.store.models.news = Field

  app.news = new NewsState(app)

  extend(IndexPage.prototype, 'navItems', function (items) {

    items.remove('tags')
    // items.remove('allDiscussions')

    items.add('news', AddNews.component(), 0)

  })


})
